import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import Dashboard from './Dashboard';
import { NewHomePage } from './NewHomePage';

type Props = RouteComponentProps<any, {}, {}>;

// TODO: Should be removed once home screen revamp phase 1 is fully rolled out
export const HomePage: React.FC<Props> = props => {
    const flags = useFlags();

    if (flags.homeScreenRevampPhase1Web) {
        return <NewHomePage {...props} />;
    } else {
        return <Dashboard {...props} />;
    }
};
